<header class="header fixed-top" style="position: fixed;">
  <nav class="navbar navbar-expand-lg navbar-dark bg-black-30">
    <div class="container">
      <div class="d-flex w-100 align-items-center justify-content-between">
        <a
        class="navbar-brand d-flex align-items-center" (click)="goToHomePage()"
      >
        <div class="logo pe-4 pe-md-5">
          <!-- <span>
            <a
              href="https://www.tatamotors.com/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <svg
                width="128"
                height="32"
                viewBox="0 0 128 32"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M2.33398 1.47949H14.143V4.95949H10.7572V13.3595H5.82302V4.95949H2.33398V1.47949Z"
                  fill="white"
                />
                <path
                  d="M20.1282 6.31949L17.6301 13.3595H12.9023L17.5682 1.47949H22.7088L27.4365 13.3595H22.6675L20.1282 6.31949Z"
                  fill="white"
                />
                <path
                  d="M26.3438 1.47949H38.1528V4.95949H34.767V13.3595H29.8328V4.95949H26.3438V1.47949Z"
                  fill="white"
                />
                <path
                  d="M44.1389 6.31949L41.6408 13.3595H36.9131L41.5376 1.47949H46.7195L51.4473 13.3595H46.6782L44.1389 6.31949Z"
                  fill="white"
                />
                <path
                  d="M111.876 8.55907C112.64 8.77907 113.011 9.29907 113.28 10.5191C113.61 11.9991 113.94 13.0191 114.085 13.3391H116.356C116.129 12.8591 115.819 11.5391 115.427 10.0391C115.097 8.87907 114.622 8.01907 113.693 7.69907V7.63907C114.89 7.25907 115.922 6.19907 115.922 4.65907C115.922 3.65907 115.53 2.79907 114.89 2.25907C114.188 1.67907 113.218 1.35907 111.876 1.29907V2.93907C113.011 3.09907 113.713 3.67907 113.713 4.85907C113.713 5.87907 113.011 6.61907 111.876 6.77907V8.55907V8.55907ZM107.768 13.3391H109.977V8.43907H111.112C111.38 8.43907 111.649 8.43907 111.876 8.53907V6.79907C111.649 6.79907 111.504 6.85907 111.277 6.85907H109.977V3.07907C110.183 3.01907 110.679 2.97907 111.38 2.97907H111.876V1.33907H111.174C109.873 1.33907 108.635 1.43907 107.768 1.55907V13.3391V13.3391Z"
                  fill="white"
                />
                <path
                  d="M118.275 12.7794C118.915 13.1994 120.278 13.5794 121.579 13.5794C124.717 13.5794 126.162 11.8994 126.162 9.99936C126.162 8.29936 125.13 7.25935 123.024 6.45935C121.413 5.87935 120.691 5.45935 120.691 4.55935C120.691 3.81935 121.29 3.07935 122.693 3.07935C123.829 3.07935 124.696 3.43935 125.13 3.65935L125.666 1.91936C125.026 1.59936 124.035 1.33936 122.755 1.33936C120.113 1.33936 118.42 2.81936 118.42 4.71936C118.42 6.45936 119.721 7.51936 121.723 8.19936C123.292 8.71936 123.891 9.25935 123.891 10.1594C123.891 11.0994 123.086 11.7994 121.682 11.7994C120.546 11.7994 119.473 11.4394 118.771 11.0194L118.275 12.7794Z"
                  fill="white"
                />
                <path
                  d="M68.1696 8.49949C68.1077 6.95949 67.9838 5.11949 67.9838 3.51949C67.5503 4.99949 67.0342 6.59949 66.518 8.07949L64.6806 13.2395H62.9671L61.3774 8.13949C60.8613 6.6595 60.4277 4.99949 60.0974 3.51949H60.0354C59.9735 5.05949 59.9116 6.95949 59.8496 8.61949L59.6019 13.3595H57.4961L58.26 1.47949H61.2329L62.8225 6.27949C63.2561 7.63949 63.6484 9.03949 63.958 10.3995H64.02C64.3296 9.09949 64.7838 7.63949 65.2174 6.21949L66.9309 1.47949H69.8625L70.5645 13.3595H68.3348L68.1696 8.49949Z"
                  fill="white"
                />
                <path
                  d="M78.2664 13.5394C81.5903 13.4994 84.0264 11.2394 84.0264 7.33936C84.0264 3.91936 81.9413 1.33936 78.3697 1.33936H78.2664V3.05935C80.4961 3.05935 81.6316 5.17935 81.6316 7.37935C81.6316 9.87935 80.4342 11.7994 78.2664 11.7994V13.5394ZM78.2251 13.5394H78.2664V11.8194C76.14 11.8194 74.9013 9.83935 74.9013 7.49936C74.9013 5.13936 76.0367 3.07935 78.2664 3.07935V1.35936C74.9013 1.39936 72.5684 3.95935 72.5684 7.55935C72.5684 11.0194 74.7567 13.5594 78.1632 13.5594H78.2251V13.5394Z"
                  fill="white"
                />
                <path
                  d="M100.047 13.5394C103.371 13.4994 105.786 11.2394 105.786 7.33936C105.786 3.91936 103.701 1.33936 100.129 1.33936H100.026V3.05935C102.256 3.05935 103.391 5.17935 103.391 7.37935C103.391 9.87935 102.194 11.7994 100.026 11.7994V13.5394H100.047ZM100.005 13.5394H100.047V11.8194C97.9202 11.8194 96.6815 9.83935 96.6815 7.49936C96.6815 5.13936 97.817 3.07935 100.047 3.07935V1.35936C96.6815 1.39936 94.3486 3.95935 94.3486 7.55935C94.3486 11.0194 96.537 13.5594 99.9641 13.5594H100.005V13.5394Z"
                  fill="white"
                />
                <path
                  d="M88.1553 13.3403H90.385V3.36028H93.8534V1.54028H84.625V3.36028H88.1553V13.3403Z"
                  fill="white"
                />
                <path
                  d="M5.55463 28.4397C3.59334 28.4397 2.33398 27.2997 2.33398 25.4197V22.2597C2.33398 20.3997 3.61398 19.2397 5.51334 19.2397C6.48366 19.2397 7.45399 19.5597 8.2385 20.1397C8.30044 20.1797 8.30044 20.2197 8.25915 20.2797L8.0114 20.6397C7.97011 20.6997 7.92882 20.6997 7.86689 20.6597C7.1856 20.1597 6.33915 19.8797 5.51334 19.8797C3.90302 19.8797 3.03592 20.8597 3.03592 22.2397V25.3997C3.03592 26.7997 3.90302 27.7597 5.53398 27.7597C6.44237 27.7597 7.35076 27.4597 8.07334 26.8797C8.13527 26.8397 8.19721 26.8397 8.21786 26.8997L8.4656 27.2597C8.50689 27.2997 8.50689 27.3597 8.44495 27.3997C7.61915 28.1397 6.56624 28.4397 5.55463 28.4397Z"
                  fill="white"
                />
                <path
                  d="M12.3044 28.44C10.5702 28.44 9.55859 27.44 9.55859 26.04V24.14C9.55859 22.76 10.5702 21.74 12.3044 21.74C14.0592 21.74 15.0502 22.78 15.0502 24.14V26.04C15.0502 27.44 14.0592 28.44 12.3044 28.44ZM12.3044 27.84C13.6876 27.84 14.3689 27.08 14.3689 26.04V24.14C14.3689 23.1 13.6876 22.34 12.3044 22.34C10.9625 22.34 10.2605 23.1 10.2605 24.14V26.04C10.2605 27.08 10.9625 27.84 12.3044 27.84Z"
                  fill="white"
                />
                <path
                  d="M16.8045 28.3203C16.7426 28.3203 16.6807 28.2803 16.6807 28.2203V22.3803C16.6807 22.3403 16.7013 22.2803 16.7632 22.2603C17.4652 21.9603 18.291 21.7803 19.1581 21.7803C20.8716 21.7803 21.9452 22.6003 21.9452 24.3803V28.2403C21.9452 28.3003 21.9039 28.3403 21.842 28.3403H21.3878C21.3258 28.3403 21.2639 28.3003 21.2639 28.2403V24.4003C21.2639 23.0003 20.5 22.4003 19.1581 22.4003C18.5181 22.4003 17.8574 22.5203 17.362 22.7003V28.2403C17.362 28.3003 17.3207 28.3403 17.2587 28.3403H16.8045V28.3203Z"
                  fill="white"
                />
                <path
                  d="M23.8866 28.3203C23.8246 28.3203 23.7627 28.2803 23.7627 28.2203V22.3803C23.7627 22.3403 23.7833 22.2803 23.8453 22.2603C24.5472 21.9603 25.373 21.7803 26.2401 21.7803C27.9537 21.7803 29.0272 22.6003 29.0272 24.3803V28.2403C29.0272 28.3003 28.9859 28.3403 28.924 28.3403H28.4698C28.4079 28.3403 28.3459 28.3003 28.3459 28.2403V24.4003C28.3459 23.0003 27.5821 22.4003 26.2401 22.4003C25.6001 22.4003 24.9395 22.5203 24.444 22.7003V28.2403C24.444 28.3003 24.4027 28.3403 24.3408 28.3403H23.8866V28.3203Z"
                  fill="white"
                />
                <path
                  d="M35.8817 25.34C35.8817 25.4 35.8404 25.44 35.7578 25.44H31.3191V26.14C31.3191 27.22 32.1862 27.84 33.2598 27.84C34.2301 27.84 34.8701 27.44 35.3656 27.04C35.4275 27 35.4894 27 35.5101 27.06L35.7372 27.34C35.7991 27.4 35.7991 27.44 35.7165 27.48C35.1178 27.98 34.3333 28.42 33.2391 28.42C31.8765 28.42 30.6172 27.6 30.6172 26.12V24.16C30.6172 22.56 31.794 21.74 33.2598 21.74C34.7049 21.74 35.8611 22.56 35.8611 24.16V25.34H35.8817ZM33.2804 22.36C32.1036 22.36 31.3398 22.98 31.3398 24.16V24.88H35.2211V24.16C35.2211 23 34.4159 22.36 33.2804 22.36Z"
                  fill="white"
                />
                <path
                  d="M39.8652 28.44C38.2136 28.44 37.2227 27.42 37.2227 26.08V24.1C37.2227 22.76 38.2136 21.74 39.8652 21.74C40.6291 21.74 41.3104 21.96 41.9298 22.38C41.9917 22.42 42.0123 22.48 41.971 22.52L41.7439 22.84C41.7027 22.88 41.6614 22.9 41.5994 22.86C41.0627 22.5 40.5052 22.32 39.8652 22.32C38.6059 22.32 37.9039 23.08 37.9039 24.06V26.04C37.9039 27.04 38.6059 27.8 39.8652 27.8C40.5465 27.8 41.1659 27.58 41.7646 27.16C41.8265 27.12 41.8885 27.12 41.9091 27.18L42.1362 27.5C42.1775 27.56 42.1775 27.62 42.1156 27.64C41.4549 28.18 40.753 28.44 39.8652 28.44Z"
                  fill="white"
                />
                <path
                  d="M45.5229 27.8196C45.6881 27.8196 45.9771 27.7996 46.2249 27.7996C46.2868 27.7796 46.3281 27.8196 46.3281 27.8996V28.2996C46.3281 28.3596 46.3074 28.3996 46.2249 28.4196C45.9978 28.4396 45.6675 28.4596 45.4816 28.4596C44.2223 28.4596 43.3965 27.7196 43.3965 26.3396V20.3996C43.3965 20.3396 43.4378 20.2996 43.4997 20.2996H43.9126C43.9745 20.2996 44.0158 20.3396 44.0365 20.3996L44.0778 21.9196H46.0391C46.101 21.9196 46.1423 21.9596 46.1423 22.0396V22.4196C46.1423 22.4796 46.101 22.5196 46.0391 22.5196H44.0778V26.2996C44.0984 27.2596 44.5733 27.8196 45.5229 27.8196Z"
                  fill="white"
                />
                <path
                  d="M47.794 20.5804C47.5256 20.5804 47.3398 20.4004 47.3398 20.1404C47.3398 19.8804 47.5256 19.7004 47.794 19.7004C48.0418 19.7004 48.2482 19.8804 48.2482 20.1404C48.2482 20.3804 48.0418 20.5804 47.794 20.5804ZM47.5463 28.3204C47.4844 28.3204 47.4431 28.2804 47.4431 28.2204V22.0204C47.4431 21.9404 47.4844 21.9004 47.5463 21.9004H48.0211C48.0831 21.9004 48.1244 21.9404 48.1244 22.0204V28.2204C48.1244 28.2804 48.0831 28.3204 48.0211 28.3204H47.5463Z"
                  fill="white"
                />
                <path
                  d="M50.1258 28.3203C50.0639 28.3203 50.002 28.2803 50.002 28.2203V22.3803C50.002 22.3403 50.0226 22.2803 50.0845 22.2603C50.7865 21.9603 51.6123 21.7803 52.4794 21.7803C54.1929 21.7803 55.2665 22.6003 55.2665 24.3803V28.2403C55.2665 28.3003 55.2252 28.3403 55.1632 28.3403H54.7091C54.6471 28.3403 54.5852 28.3003 54.5852 28.2403V24.4003C54.5852 23.0003 53.8213 22.4003 52.4794 22.4003C51.8394 22.4003 51.1787 22.5203 50.6832 22.7003V28.2403C50.6832 28.3003 50.642 28.3403 50.58 28.3403H50.1258V28.3203Z"
                  fill="white"
                />
                <path
                  d="M59.5197 30.8003C58.5081 30.8003 57.7442 30.4603 57.0835 29.8603C57.0423 29.8203 57.0423 29.7803 57.0629 29.7203L57.29 29.4003C57.3313 29.3603 57.3726 29.3403 57.4345 29.3803C57.9919 29.8603 58.6526 30.2003 59.5197 30.2003C60.8616 30.2003 61.4397 29.5203 61.4397 28.3003V27.6803C60.9029 27.9203 60.2216 28.1003 59.6023 28.1003C57.9919 28.1003 56.8564 27.2803 56.8564 25.6003V24.3003C56.8564 22.5203 58.0332 21.7803 59.6435 21.7803C60.4693 21.7803 61.3571 21.9603 62.0177 22.2403C62.0797 22.2603 62.1003 22.3203 62.1003 22.3603V28.3603C62.121 29.8003 61.3364 30.8003 59.5197 30.8003ZM59.6229 27.4803C60.2835 27.4803 60.9442 27.3003 61.419 27.0403V22.6203C60.9442 22.4603 60.1803 22.3403 59.6229 22.3403C58.3223 22.3403 57.5377 22.9003 57.5377 24.2403V25.5403C57.5584 26.9403 58.3842 27.4803 59.6229 27.4803Z"
                  fill="white"
                />
                <path
                  d="M65.9405 28.3202C65.8786 28.3202 65.8373 28.2602 65.8579 28.2002L69.1405 19.5002C69.1611 19.4602 69.2024 19.4202 69.2644 19.4202H69.9044C69.9457 19.4202 69.9869 19.4602 70.0282 19.5002L73.3315 28.2002C73.3521 28.2802 73.3108 28.3202 73.2489 28.3202H72.7121C72.6502 28.3202 72.6089 28.2802 72.5882 28.2402L71.6592 25.7202H67.5508L66.6218 28.2402C66.6011 28.3002 66.5598 28.3202 66.4979 28.3202H65.9405ZM67.7573 25.0802H71.4321L69.6153 20.2002H69.574L67.7573 25.0802Z"
                  fill="white"
                />
                <path
                  d="M76.4881 28.4403C75.5591 28.4403 74.7333 28.1603 74.0107 27.6403C73.9487 27.6003 73.9487 27.5603 73.9694 27.5003L74.1965 27.1603C74.2378 27.1003 74.2791 27.0803 74.3616 27.1403C75.0016 27.6003 75.7242 27.8603 76.5294 27.8603C77.5823 27.8603 78.3255 27.4203 78.3255 26.6203C78.3255 25.7403 77.3758 25.5403 76.5294 25.3803C75.5178 25.2003 74.0933 24.8203 74.0933 23.4803C74.0933 22.3603 75.1874 21.7803 76.4674 21.7803C77.3552 21.7803 78.0571 22.0203 78.7178 22.3803C78.7797 22.4203 78.8003 22.4603 78.7591 22.5203L78.5526 22.8603C78.532 22.9203 78.47 22.9403 78.4081 22.9003C77.8507 22.5803 77.1694 22.3803 76.4468 22.3803C75.4352 22.3803 74.7539 22.8003 74.7539 23.4803C74.7539 24.3403 75.6829 24.5803 76.6532 24.7803C77.7681 25.0003 79.0274 25.2803 79.0274 26.6003C78.9862 27.7203 78.0365 28.4403 76.4881 28.4403Z"
                  fill="white"
                />
                <path
                  d="M82.8906 21.7605C84.5629 21.7605 85.6777 22.5805 85.6777 24.4405V25.7805C85.6777 27.5405 84.6042 28.4405 82.9319 28.4405C82.2506 28.4405 81.59 28.2405 81.0945 27.9405V30.5605C81.0945 30.6205 81.0532 30.6605 80.9913 30.6605H80.5165C80.4545 30.6605 80.3926 30.6205 80.3926 30.5605V22.3205C80.3926 22.2605 80.4132 22.2205 80.4752 22.2005C81.1977 21.9405 82.0442 21.7605 82.8906 21.7605ZM84.9758 25.7805V24.4405C84.9758 22.9605 84.2119 22.3605 82.8906 22.3605C82.23 22.3605 81.6106 22.4805 81.0945 22.6605V27.3005C81.59 27.6405 82.23 27.8405 82.8906 27.8405C84.2326 27.8405 84.9758 27.2205 84.9758 25.7805Z"
                  fill="white"
                />
                <path
                  d="M87.6603 20.5804C87.3919 20.5804 87.2061 20.4004 87.2061 20.1404C87.2061 19.8804 87.3919 19.7004 87.6603 19.7004C87.908 19.7004 88.1144 19.8804 88.1144 20.1404C88.1144 20.3804 87.908 20.5804 87.6603 20.5804ZM87.4125 28.3204C87.3506 28.3204 87.3093 28.2804 87.3093 28.2204V22.0204C87.3093 21.9404 87.3506 21.9004 87.4125 21.9004H87.8873C87.9493 21.9004 87.9906 21.9404 87.9906 22.0204V28.2204C87.9906 28.2804 87.9493 28.3204 87.8873 28.3204H87.4125Z"
                  fill="white"
                />
                <path
                  d="M89.992 28.3203C89.9301 28.3203 89.8682 28.2803 89.8682 28.2203V22.3403C89.8682 22.2803 89.8888 22.2403 89.9507 22.2203C90.5907 21.9403 91.3753 21.7803 92.1185 21.7803C92.552 21.7803 92.9856 21.8403 93.4398 21.9003C93.5224 21.9203 93.543 21.9603 93.543 22.0203V22.4003C93.543 22.4603 93.4811 22.5003 93.4191 22.4803C93.0269 22.4203 92.5933 22.3803 92.2011 22.3803C91.6024 22.3803 91.0037 22.5003 90.5495 22.6803V28.2403C90.5495 28.3003 90.5082 28.3403 90.4462 28.3403H89.992V28.3203Z"
                  fill="white"
                />
                <path
                  d="M96.8043 21.7605C98.3939 21.7605 99.261 22.6205 99.261 24.1205V27.9005C99.261 27.9605 99.2404 28.0005 99.1785 28.0205C98.621 28.2405 97.7333 28.4405 96.7836 28.4405C95.2972 28.4405 94.0791 27.7605 94.0791 26.4205C94.0791 25.1405 95.1114 24.4605 96.7836 24.4605C97.4443 24.4605 98.1049 24.5805 98.5797 24.6605V24.1205C98.5797 23.0205 98.0843 22.3605 96.7836 22.3605C96.0197 22.3605 95.2972 22.5805 94.8223 22.8805C94.781 22.9205 94.7191 22.9005 94.6778 22.8605L94.4507 22.5405C94.4094 22.5005 94.4094 22.4405 94.4507 22.4205C95.0081 22.0205 95.8339 21.7605 96.8043 21.7605ZM96.7836 27.8405C97.5062 27.8405 98.1256 27.7005 98.5797 27.5405V25.2205C98.1049 25.1205 97.4236 25.0405 96.7836 25.0405C95.4417 25.0405 94.781 25.5405 94.781 26.4205C94.7604 27.3205 95.6068 27.8405 96.7836 27.8405Z"
                  fill="white"
                />
                <path
                  d="M103.123 27.8196C103.288 27.8196 103.577 27.7996 103.824 27.7996C103.886 27.7796 103.928 27.8196 103.928 27.8996V28.2996C103.928 28.3596 103.907 28.3996 103.824 28.4196C103.597 28.4396 103.267 28.4596 103.081 28.4596C101.822 28.4596 100.996 27.7196 100.996 26.3396V20.3996C100.996 20.3396 101.037 20.2996 101.099 20.2996H101.512C101.574 20.2996 101.615 20.3396 101.636 20.3996L101.677 21.9196H103.639C103.701 21.9196 103.742 21.9596 103.742 22.0396V22.4196C103.742 22.4796 103.701 22.5196 103.639 22.5196H101.677V26.2996C101.698 27.2596 102.194 27.8196 103.123 27.8196Z"
                  fill="white"
                />
                <path
                  d="M105.394 20.5804C105.125 20.5804 104.939 20.4004 104.939 20.1404C104.939 19.8804 105.125 19.7004 105.394 19.7004C105.641 19.7004 105.848 19.8804 105.848 20.1404C105.848 20.3804 105.662 20.5804 105.394 20.5804ZM105.167 28.3204C105.105 28.3204 105.063 28.2804 105.063 28.2204V22.0204C105.063 21.9404 105.105 21.9004 105.167 21.9004H105.641C105.703 21.9004 105.745 21.9404 105.745 22.0204V28.2204C105.745 28.2804 105.703 28.3204 105.641 28.3204H105.167Z"
                  fill="white"
                />
                <path
                  d="M110.142 28.44C108.408 28.44 107.396 27.44 107.396 26.04V24.14C107.396 22.76 108.408 21.74 110.142 21.74C111.897 21.74 112.888 22.78 112.888 24.14V26.04C112.867 27.44 111.876 28.44 110.142 28.44ZM110.142 27.84C111.526 27.84 112.207 27.08 112.207 26.04V24.14C112.207 23.1 111.526 22.34 110.142 22.34C108.8 22.34 108.098 23.1 108.098 24.14V26.04C108.078 27.08 108.78 27.84 110.142 27.84Z"
                  fill="white"
                />
                <path
                  d="M114.622 28.3203C114.56 28.3203 114.498 28.2803 114.498 28.2203V22.3803C114.498 22.3403 114.519 22.2803 114.581 22.2603C115.283 21.9603 116.108 21.7803 116.975 21.7803C118.689 21.7803 119.763 22.6003 119.763 24.3803V28.2403C119.763 28.3003 119.721 28.3403 119.659 28.3403H119.205C119.143 28.3403 119.081 28.3003 119.081 28.2403V24.4003C119.081 23.0003 118.317 22.4003 116.975 22.4003C116.335 22.4003 115.675 22.5203 115.179 22.7003V28.2403C115.179 28.3003 115.138 28.3403 115.076 28.3403H114.622V28.3203Z"
                  fill="white"
                />
                <path
                  d="M123.684 28.4403C122.755 28.4403 121.93 28.1603 121.207 27.6403C121.145 27.6003 121.145 27.5603 121.166 27.5003L121.393 27.1603C121.434 27.1003 121.475 27.0803 121.558 27.1403C122.198 27.6003 122.921 27.8603 123.726 27.8603C124.779 27.8603 125.522 27.4203 125.522 26.6203C125.522 25.7403 124.572 25.5403 123.726 25.3803C122.714 25.2003 121.29 24.8203 121.29 23.4803C121.29 22.3603 122.384 21.7803 123.664 21.7803C124.551 21.7803 125.253 22.0203 125.914 22.3803C125.976 22.4203 125.997 22.4603 125.955 22.5203L125.749 22.8603C125.728 22.9203 125.666 22.9403 125.604 22.9003C125.047 22.5803 124.366 22.3803 123.643 22.3803C122.631 22.3803 121.95 22.8003 121.95 23.4803C121.95 24.3403 122.879 24.5803 123.85 24.7803C124.964 25.0003 126.224 25.2803 126.224 26.6003C126.182 27.7203 125.233 28.4403 123.684 28.4403Z"
                  fill="white"
                />
              </svg>
            </a>
          </span> -->
          <a href="https://www.tatamotors.com/" target="_blank">
            <img width="100%"
              *ngIf="isLightLogo"
              alt="better_always_dark"
              [src]='environment1 + "assets/images/better_always_light.png"'
            />
          </a>
          <a>
            <img width="100%"
              *ngIf="isDarkLogo"
              alt="better_always_light"
              [src]='environment1 + "assets/images/better_always_dark.png"'
            />
          </a>
        </div>
        <div class="logo-content">
          <a>
            <img
              *ngIf="isLightLogo"
              alt="fleetverse_logo_white"
              [src]='environment1 + "assets/images/osp_logo_white.png"'
            />
          </a>
          <a>
            <img
              *ngIf="isDarkLogo"
              alt="fleetverse_logo_dark"
              [src]='environment1 + "assets/images/osp_logo_dark.png"'
            />
          </a>
        </div>
      </a>
        <div class="tata-logo p-2 d-lg-none">

          <div class="rtl-content d-flex">
            <div class="user-profile p-2 position-relative cursor-pointer d-none d-md-none ">
              <a (click)="redirect('notifications')" class="d-inline-block" id="dropdownMenuClickableInsidenotification"
                data-bs-toggle="dropdown" data-bs-auto-close="outside" aria-expanded="false">
                <img [src]="environment1 + 'images/new-images/notifications.svg'" alt="browse" loading="lazy">
                <!-- <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <g clip-path="url(#clip0_2256_784)">
                    <path
                      d="M5 18H19V11.031C19 7.148 15.866 4 12 4C8.134 4 5 7.148 5 11.031V18ZM12 2C16.97 2 21 6.043 21 11.031V20H3V11.031C3 6.043 7.03 2 12 2ZM9.5 21H14.5C14.5 21.663 14.2366 22.2989 13.7678 22.7678C13.2989 23.2366 12.663 23.5 12 23.5C11.337 23.5 10.7011 23.2366 10.2322 22.7678C9.76339 22.2989 9.5 21.663 9.5 21Z"
                      fill="white" />
                  </g>
                  <defs>
                    <clipPath id="clip0_2256_784">
                      <rect width="24" height="24" fill="white" />
                    </clipPath>
                  </defs>
                </svg> -->
              </a>
              <!-- <ul class="dropdown-menu dropdown-menu-center" aria-labelledby="dropdownMenuClickableInsidenotification">
                            <li class="options"><a class="dropdown-item" [routerLink]=""></a></li>
                            <li class="options"><a class="dropdown-item" [routerLink]=""></a></li>
                            <li class="options"><a class="dropdown-item" [routerLink]=""></a></li>
                            <li class="options"><a class="dropdown-item" [routerLink]=""></a></li>
                            <li class="options"><a class="dropdown-item" [routerLink]=""></a></li>
                            <li class="options"><a class="dropdown-item" [routerLink]=""></a></li>
                            <li class="options"><a class="dropdown-item" [routerLink]=""></a></li>
                            <li class="options"><a class="dropdown-item" [routerLink]=""></a></li>
                        </ul> -->
            </div>

            <div class="user-profile p-2 position-relative  cursor-pointer d-none d-md-block">
              <a (click)="redirect('wishList')" class="d-inline-block" id="dropdownMenuClickableInsidenotification"
                data-bs-toggle="dropdown" data-bs-auto-close="outside" aria-expanded="false">
                <img [src]="environment1 + 'images/new-images/heart.svg'" alt="heart" loading="lazy">
              </a>
              <!-- <ul class="dropdown-menu dropdown-menu-center" aria-labelledby="dropdownMenuClickableInsidenotification">
                            <li class="options"><a class="dropdown-item" [routerLink]=""></a></li>
                            <li class="options"><a class="dropdown-item" [routerLink]=""></a></li>
                            <li class="options"><a class="dropdown-item" [routerLink]=""></a></li>
                            <li class="options"><a class="dropdown-item" [routerLink]=""></a></li>
                            <li class="options"><a class="dropdown-item" [routerLink]=""></a></li>
                            <li class="options"><a class="dropdown-item" [routerLink]=""></a></li>
                            <li class="options"><a class="dropdown-item" [routerLink]=""></a></li>
                            <li class="options"><a class="dropdown-item" [routerLink]=""></a></li>
                        </ul> -->
            </div>

            <div class="user-profile p-2 position-relative  cursor-pointer d-none d-md-block">
              <a href="javascript:void(0)" class="d-inline-block dropdown-toggle" id="dropdownMenuClickableInside"
                data-bs-toggle="dropdown" data-bs-auto-close="true" aria-expanded="false">
                <img [src]="environment1 + 'images/new-images/person.svg'" alt="person" loading="lazy">
              </a>
              <ul class="dropdown-menu dropdown-menu-center" aria-labelledby="dropdownMenuClickableInside">

                <li class="title"> {{isUserLoggedIn && userData ? 'Hi ' + fName + " " +
                  lName : 'Welcome' }}</li>
                <li class="sub-title mb-3">{{isUserLoggedIn && userData ? 'Access' : 'To access' }} your account and
                  manage your orders</li>

                <li class=" pb-3 " [ngClass]="isUserLoggedIn ? 'border-bottom' : ''"><button type="button"
                    (click)="onLoginClick()" class="btn btn-outline-primary w-100"> {{isUserLoggedIn && userData?
                    'Logout' :
                    'Login/Signup'}}</button></li>
                <li class="options" *ngIf="isUserLoggedIn"><a class="dropdown-item"
                    [routerLink]="'/account/profilePage'">My Profile</a></li>
                <li class="options" *ngIf="isUserLoggedIn"><a class="dropdown-item" [routerLink]="'/account/booking'">My
                    Finance & Bookings</a></li>
                <li class="options" *ngIf="isUserLoggedIn"><a class="dropdown-item"
                    [routerLink]="'/account/testDrive'">My
                    Test Drive</a></li>
                <li class="options" *ngIf="isUserLoggedIn"><a class="dropdown-item"
                    [routerLink]="'/account/wishList'">My
                    Wish List</a></li>

                <li class="options" *ngIf="isUserLoggedIn"><a class="dropdown-item" [routerLink]="'/account/kyc'">My Kyc</a></li>
                <li class="options" *ngIf="isUserLoggedIn"><a class="dropdown-item" [routerLink]="'/account/vas-dashboard'">VAS-DASHBOARD</a></li>
                    <!-- <li class="options" *ngIf="isUserLoggedIn"><a class="dropdown-item" [routerLink]="'/account/configuration'">My
                      Configurator</a></li>  -->
              </ul>
            </div>



            <!---for tablet-->
            <div class="tab-divider">

            </div>
            <button class="navbar-toggler d-none d-md-block" type="button" data-bs-toggle="offcanvas"
              data-bs-target="#offcanvasRight" aria-controls="offcanvasRight" aria-controls="navbarSupportedContent"
              aria-expanded="false" aria-label="Toggle navigation">
              <!-- <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g clip-path="url(#clip0_171_1809)">
                  <path d="M3 4H21V6H3V4ZM3 11H15V13H3V11ZM3 18H21V20H3V18Z" fill="#0A0A5F" />
                </g>
                <defs>
                  <clipPath id="clip0_171_1809">
                    <rect width="24" height="24" fill="#0A0A5F" />
                  </clipPath>
                </defs>
              </svg> -->
              <img [src]="environment1 + 'images/new-images/notes.svg'" alt="notes" loading="lazy">
            </button>



            <div class="tata-logo logo-padding">
              <span>
                <a href="https://www.tata.com/" target="_blank" rel="noopener noreferrer">
                  <img  [src]="environment1 + 'images/new-images/tatalogoBlack.svg'" alt="tata" loading="lazy">

                </a>
              </span>
            </div>
          </div>



        </div>
      </div>
      <div class="d-flex align-items-center rtl-content d-lg-none w-100">
        <div class="nav-item search-p-scroll position-relative w-100">
          <input type="search" class="form-control form-control-sm search-control"
            (focus)="showMobileBannerSearch(true)" (blur)="onFocusOutRemoveSpace()" #searchInput
            placeholder="Find your commercial vehicle" [(ngModel)]="searchData"(keypress)="onKeyPressspace($event)"
          (input)="getAutoSuggest(searchData)" id="globalSmartSearch" (keydown.enter)="searchAll()"
          style="border:3px solid #c8c8cd" />
          <div class="search-modal-auto" *ngIf="!isMobileBannerSearchShow">
            <ul class="dropdown-menu-end auto-complete-wrapper-search" style="float: left;"
              [ngClass]="searchModels?.length == 0 ? 'd-none' : ''" *ngIf="searchModels?.length > 0">
              <li *ngFor="let data of searchModels" style="cursor: pointer; padding: 5px; list-style: none;">
                <a (mousedown)="searchSingle(data)"><img src="" loading="lazy">{{ data.model }}</a>
              </li>
            </ul>
            <ul class="dropdown-menu-end auto-complete-wrapper-search float-left"
              [ngClass]="searchModels?.length == 0 ? 'd-block' : ''"
              *ngIf="searchModels?.length == 0 && searchData?.length > 2">
              <li class="mbl-li-padding">
                <a><img src="" loading="lazy">No data found.</a>
              </li>
            </ul>
          </div>
        </div>

        <!-- <div class="search-box">
          <input type="text" class="form-control">
        </div> -->
        <!---for mobile-->
        <div class="user-profile p-2 position-relative  cursor-pointer d-md-none">
          <a href="javascript:void(0)" class="d-inline-block dropdown-toggle" id="dropdownMenuClickableInside"
            data-bs-toggle="dropdown" data-bs-auto-close="true" aria-expanded="false">
            <img [src]="environment1 + 'images/new-images/person.svg'" alt="person" loading="lazy">
          </a>
          <ul class="dropdown-menu dropdown-menu-end" aria-labelledby="dropdownMenuClickableInside">

            <li class="title"> {{isUserLoggedIn && userData ? 'Hi ' + fName + " " +
              lName : 'Welcome' }}</li>
            <li class="sub-title mb-3">{{isUserLoggedIn ? 'Access' : 'To access' }} your account and
              manage your orders</li>

            <li class=" pb-3 " [ngClass]="isUserLoggedIn ? 'border-bottom' : ''"><button type="button"
                (click)="onLoginClick()" class="btn btn-outline-primary w-100"> {{isUserLoggedIn ? 'Logout' :
                'Login/Signup'}}</button></li>
            <li class="options" *ngIf="isUserLoggedIn"><a class="dropdown-item" [routerLink]="'/account/profilePage'">My
                Profile</a></li>
            <li class="options" *ngIf="isUserLoggedIn"><a class="dropdown-item" [routerLink]="'/account/booking'">My
                Finance & Bookings</a></li>
            <li class="options" *ngIf="isUserLoggedIn"><a class="dropdown-item" [routerLink]="'/account/testDrive'">My
                Test Drive</a></li>
            <li class="options" *ngIf="isUserLoggedIn"><a class="dropdown-item" [routerLink]="'/account/wishList'">My
                Wish List</a></li>
            <li class="options" *ngIf="isUserLoggedIn"><a class="dropdown-item" [routerLink]="'/account/kyc'">My
                Kyc</a></li>
                <li class="options" *ngIf="isUserLoggedIn"><a class="dropdown-item" [routerLink]="'/account/vas-dashboard'">VAS-DASHBOARD</a></li>
                <!-- <li class="options" *ngIf="isUserLoggedIn"><a class="dropdown-item" [routerLink]="'/account/configuration'">My
                  Configurator</a></li> -->
          </ul>
        </div>
        <button class="navbar-toggler d-md-none" type="button" data-bs-toggle="offcanvas"
          data-bs-target="#offcanvasRight" aria-controls="offcanvasRight" aria-controls="navbarSupportedContent"
          aria-expanded="false" aria-label="Toggle navigation">
          <img [src]="environment1 + 'images/new-images/notes.svg'" alt="notes" loading="lazy">
        </button>

        <!---for mobile-->

      </div>
      <!--onclick show list-mobile-view-->
      <div class="div-verticle-scroll"
        [ngClass]="{'d-lg-none': isMobileBannerSearchShow === true, 'd-none' : isMobileBannerSearchShow === false }"
        id="mobileBannerSearch" #mobileBannerSearch>

        <h4 class="trending-txt">Top Applications</h4>
        <span class="d-flex mb-4" style="flex-wrap: wrap; height: 100px; overflow-y: scroll;">
          <div class="search-text-cheap" *ngFor="let item of applicationData">
            <span class="search-text" (click)="bannerSearch('Application',item)">{{ item }}</span>
          </div>
        </span>
        <!--segments div-->
        <h4 class="trending-txt">Segments</h4>
        <div class="segmnt-div">
          <span class="d-flex">
            <div style="margin-right: 10px;" *ngFor="let item of segmentsData">
              <img (click)="bannerSearch('Segment',item.eleName)" [src]="item.img_url" height="75px" width="75px"
                loading="lazy">
              <h4 (click)="bannerSearch('Segment',item.eleName)" class="sub-text">{{item.eleName}}</h4>
            </div>
          </span>
        </div>
        <h4 class="trending-txt">Trending Product/Model</h4>
        <span class="d-flex trending-mbl-tag">
          <div class="search-text-cheap" *ngFor="let item of productModelData">
            <span class="search-text " (click)="bannerSearch('Model',item)"><span style="margin-right: 8px;">
              <img [src]="environment1 + 'images/new-images/navigate.svg'" alt="navigate" loading="lazy"></span>{{ item }}</span>
          </div>
        </span>
        <div class="col-auto ps-0 d-flex mt-2 btn-right">
          <button class="btn btn-search" (click)="showMobileBannerSearch(false)">
            Close
          </button>
        </div>
      </div>
      <div class="mobileveiwdealername d-md-none"  *ngIf="dealerName">
        Dealer Name: {{dealerName}}
      </div>
      <!--onclick show list-mobile-view -->

      <div class="collapse navbar-collapse" id="navbarSupportedContent">
        <ul class="navbar-nav mx-auto mb-2 mb-lg-0 fw-bold">
          <li class="nav-item search-p-scroll position-relative">
            <input type="search" class="form-control form-control-sm search-control"
              placeholder="Find your commercial vehicle" (blur)="onFocusOutRemoveSpace()"  [(ngModel)]="searchData"  (keypress)="onKeyPressspace($event)"
              (input)="getAutoSuggest(searchData)" (keydown.enter)="searchAll()"
              style="border:3px solid #c8c8cd" />
            <div class="search-modal-auto">
              <ul class="dropdown-menu-end auto-complete-wrapper-search float-left"
                [ngClass]="(searchModels?.length == 0 && displaySearchDrp) ? 'd-none' : ''" *ngIf="searchModels?.length > 0">
                <li class="mbl-li-padding" *ngFor="let data of searchModels">
                  <a (mousedown)="searchSingle(data)"><img src="" loading="lazy">{{ data.model }}</a>
                </li>
              </ul>
              <ul class="dropdown-menu-end auto-complete-wrapper-search float-left"
                [ngClass]="searchModels?.length == 0 ? 'd-block' : ''"
                *ngIf="searchModels?.length == 0 && searchData?.length > 2">
                <li class="mbl-li-padding">
                  <a><img src="" loading="lazy">No data found.</a>
                </li>
              </ul>
            </div>
          </li>
          <li class="nav-item dropdown has-megamenu">
            <a class="nav-link dropdown-toggle cursor" data-bs-toggle="dropdown" data-bs-auto-close="true"
              aria-expanded="false" (click)="getTotalMenu('trucks','')">
              Trucks
            </a>
            <div class="dropdown-menu megamenu">
              <div class="container px-0">
                <div class="d-flex align-items-start">
                  <div class="nav flex-column nav-pills me-3 mega-vertical-tab" id="v-pills-tab" role="tablist"
                    aria-orientation="vertical">
                    <ul>
                      <li *ngFor="let item of menu; let i=index" (mouseenter)="onSubMenuClick('trucks',item.name)"><a
                          class="dropdown-item" [routerLink]="clickEvent('trucks',item.name)"
                          class="megatab active" id="{{'tab' + i}}" data-bs-toggle="pill" data-bs-target="#t1"
                          role="tab" aria-controls="#t1" aria-selected="true">{{item.display_name}}<img
                            alt="caret-right-black" *ngIf="subMenuType == item.name"
                            [src]='environment1 + "assets/images/caret-right-black.svg"' loading="lazy"
                            alt="caret-right-black" /></a></li>
                    </ul>
                  </div>
                  <div class="tab-content mega-vertical-content" id="v-pills-tabContent">
                    <div class="tab-pane fade show active" id="t1" role="tabpanel" aria-labelledby="t1-tab">
                      <div class="container-fluid">
                        <div class="row g-3 row-cols-5">
                          <div class="col" *ngFor="let item of subMenu">
                            <a [routerLink]="generateSeoFriendlyUrl('trucks', item?.display_ppl)"(click)="clearState()"  class="menu-option">
                              <div class="menu-img">
                                <img alt="{{item?.actual_ppl}}" [src]="item.image" class="img-fluid" loading="lazy" />
                              </div>
                              <div class="menu-title">
                                {{item?.actual_ppl}}
                              </div>
                            </a>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </li>

          <li class="nav-item dropdown has-megamenu">
            <a class="nav-link dropdown-toggle cursor" data-bs-toggle="dropdown" data-bs-auto-close="true"
              aria-expanded="false" (click)="getTotalMenu('buses','')">
              Buses & Vans
            </a>
            <div class="dropdown-menu megamenu" role="menu" aria-labelledby="navbarDropdown">
              <div class="container">
                <div class="d-flex align-items-start">
                  <div class="nav flex-column nav-pills me-3 mega-vertical-tab" id="v-pills-tab" role="tablist"
                    aria-orientation="vertical">
                    <ul *ngFor="let item of menu">
                      <li (mouseenter)="onSubMenuClick('buses',item.name)"><a
                          [routerLink]="clickEvent('buses-vans',item.name)" class="megatab active" id="t11-tab"
                          data-bs-toggle="pill" data-bs-target="#t11" role="tab" aria-controls="#t11"
                          aria-selected="true">{{item.display_name}}<img alt="caret-right-black"
                            *ngIf="subMenuType == item.name"
                            [src]='environment1 + "assets/images/caret-right-black.svg"' loading="lazy" /></a></li>
                    </ul>

                  </div>
                  <div class="tab-content mega-vertical-content" id="v-pills-tabContent">
                    <div class="tab-pane fade show active" id="t11" role="tabpanel" aria-labelledby="t11-tab">
                      <div class="container-fluid">
                        <div class="row g-3 row-cols-5">
                          <div class="col" *ngFor="let item of subMenu">
                            <a [routerLink]="generateSeoFriendlyUrl('buses', item?.display_ppl)" (click)="clearState()" class="menu-option">
                              <div class="menu-img">
                                <img alt="{{item.actual_ppl}}" [src]="item.image" class="img-fluid" loading="lazy" />
                              </div>
                              <div class="menu-title">
                                {{item.actual_ppl}}
                              </div>
                            </a>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </li>
          <li class="nav-item dropdown has-megamenu">
            <a class="nav-link dropdown-toggle cursor" data-bs-toggle="dropdown" data-bs-auto-close="true"
              aria-expanded="false" (click)="getTotalMenu('SCVPickups', '')">
              SCV & Pickups
            </a>
            <div class="dropdown-menu megamenu" role="menu" aria-labelledby="navbarDropdown">
              <div class="container">
                <div class="d-flex align-items-start">
                  <div class="nav flex-column nav-pills me-3 mega-vertical-tab" id="v-pills-tab" role="tablist"
                    aria-orientation="vertical">
                    <ul *ngFor="let item of menu">
                      <li (mouseenter)="onSubMenuClick('SCVPickups',item.name)"><a
                          [routerLink]="clickEvent('scv-pickups',item.name)" class="megatab active" id="t21-tab"
                          data-bs-toggle="pill" data-bs-target="#t21" role="tab" aria-controls="#t21"
                          aria-selected="true">{{item.display_name}}<img alt="caret-right-black"
                            *ngIf="subMenuType == item.name"
                            [src]='environment1 + "assets/images/caret-right-black.svg"' loading="lazy" /></a></li>
                    </ul>
                  </div>
                  <div class="tab-content mega-vertical-content" id="v-pills-tabContent">
                    <div class="tab-pane fade show active" id="t21" role="tabpanel" aria-labelledby="t21-tab">
                      <div class="container-fluid">
                        <div class="row g-3 row-cols-5">
                          <div class="col" *ngFor="let item of subMenu">
                            <a [routerLink]="generateSeoFriendlyUrl('SCV Pickups', item?.display_ppl)" (click)="clearState()" class="menu-option">
                              <div class="menu-img">
                                <img alt=" {{item.actual_ppl}}" [src]="item.image" class="img-fluid" loading="lazy" />
                              </div>
                              <div class="menu-title">
                                {{item.actual_ppl}}
                              </div>
                            </a>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

            </div>
          </li>
        </ul>
        <div class="rtl-content d-flex">
          <div class="user-profile p-2 position-relative cursor-pointer">
          </div>
          <div class="user-profile p-2 position-relative  cursor-pointer">
            <a (click)="goToadvancesearch()" data-bs-target="#searchConsoleDefult"  style="    border: none;background: transparent; padding-right: 14px;" class="d-inline-block" id="dropdownMenuClickableInsidenotification"
              data-bs-auto-close="outside" aria-expanded="false">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M10.6144 6.2254C10.277 5.4528 9.20776 5.4528 8.8704 6.2254L7.99275 8.23559C7.21171 10.0244 5.80589 11.4484 4.0523 12.2268L1.63658 13.2991C0.868536 13.64 0.868537 14.7573 1.63658 15.0982L3.97685 16.1371C5.77553 16.9355 7.20657 18.4122 7.97427 20.2621L8.8633 22.4043C9.19319 23.1992 10.2916 23.1992 10.6215 22.4043L11.5105 20.2621C12.2782 18.4122 13.7092 16.9355 15.5079 16.1371L17.8482 15.0982C18.6162 14.7573 18.6162 13.64 17.8482 13.2991L15.4325 12.2268C13.6789 11.4484 12.2731 10.0244 11.492 8.23559L10.6144 6.2254ZM4.53956 14.1987C6.8254 13.184 8.68402 11.5162 9.74238 9.2214C10.8008 11.5162 12.6594 13.184 14.9452 14.1987C12.6321 15.2254 10.7676 16.9745 9.74239 19.3101C8.71719 16.9745 6.85267 15.2254 4.53956 14.1987ZM19.4014 1.3311L19.6482 1.8968C20.0882 2.9054 20.8807 3.7085 21.8695 4.1478L22.6299 4.4857C23.0412 4.6684 23.0412 5.2661 22.6299 5.4488L21.9121 5.7678C20.8978 6.2184 20.0911 7.0512 19.6586 8.0941L19.4052 8.70539C19.2285 9.13139 18.6395 9.13139 18.4628 8.70539L18.2094 8.0941C17.777 7.0512 16.9703 6.2184 15.956 5.7678L15.2381 5.4488C14.8269 5.2661 14.8269 4.6684 15.2381 4.4857L15.9985 4.1478C16.9874 3.7085 17.7798 2.9054 18.2198 1.8968L18.4667 1.3311C18.6473 0.916996 19.2207 0.916996 19.4014 1.3311ZM18.3745 4.9741L18.937 5.5327L19.4878 4.9741L18.937 4.4312L18.3745 4.9741Z" fill="white"/>
                </svg>

            </a>
          </div>

          <div class="user-profile p-2 position-relative  cursor-pointer">
            <a (click)="redirect('wishList')" class="d-inline-block" id="dropdownMenuClickableInsidenotification"
               data-bs-auto-close="outside" aria-expanded="false">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g clip-path="url(#clip0_2256_785)">
                  <path
                    d="M12.001 4.52898C14.35 2.41998 17.98 2.48998 20.243 4.75698C22.505 7.02498 22.583 10.637 20.479 12.993L11.999 21.485L3.52101 12.993C1.41701 10.637 1.49601 7.01898 3.75701 4.75698C6.02201 2.49298 9.64501 2.41698 12.001 4.52898ZM18.827 6.16998C17.327 4.66798 14.907 4.60698 13.337 6.01698L12.002 7.21498L10.666 6.01798C9.09101 4.60598 6.67601 4.66798 5.17201 6.17198C3.68201 7.66198 3.60701 10.047 4.98001 11.623L12 18.654L19.02 11.624C20.394 10.047 20.319 7.66498 18.827 6.16998Z"
                    fill="white" />
                </g>
                <defs>
                  <clipPath id="clip0_2256_785">
                    <rect width="24" height="24" fill="white" />
                  </clipPath>
                </defs>
              </svg>
            </a>
          </div>

          <div class="user-profile p-2 position-relative  cursor-pointer">
            <a href="javascript:void(0)" class="d-inline-block dropdown-toggle" id="dropdownMenuClickableInside"
              data-bs-toggle="dropdown" data-bs-auto-close="true" aria-expanded="false" (click)="getLoyalitySignup()">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g clip-path="url(#clip0_171_1806)">
                  <path
                    d="M4 22C4 19.8783 4.84285 17.8434 6.34315 16.3431C7.84344 14.8429 9.87827 14 12 14C14.1217 14 16.1566 14.8429 17.6569 16.3431C19.1571 17.8434 20 19.8783 20 22H18C18 20.4087 17.3679 18.8826 16.2426 17.7574C15.1174 16.6321 13.5913 16 12 16C10.4087 16 8.88258 16.6321 7.75736 17.7574C6.63214 18.8826 6 20.4087 6 22H4ZM12 13C8.685 13 6 10.315 6 7C6 3.685 8.685 1 12 1C15.315 1 18 3.685 18 7C18 10.315 15.315 13 12 13ZM12 11C14.21 11 16 9.21 16 7C16 4.79 14.21 3 12 3C9.79 3 8 4.79 8 7C8 9.21 9.79 11 12 11Z"
                    fill="white" />
                </g>
                <defs>
                  <clipPath id="clip0_171_1806">
                    <rect width="24" height="24" fill="white" />
                  </clipPath>
                </defs>
              </svg>
            </a>
            <ul class="dropdown-menu dropdown-menu-center" aria-labelledby="dropdownMenuClickableInside">

              <li class="title"> {{isUserLoggedIn && userData ? 'Hi ' + fName + " " +
                lName : 'Welcome' }}</li>
              <li class="sub-title mb-3">{{isUserLoggedIn ? 'Access' : 'To access' }} your account and
                manage your orders</li>

              <li class=" pb-3 " [ngClass]="isUserLoggedIn ? 'border-bottom' : ''"><button type="button"
                  (click)="onLoginClick()" class="btn btn-outline-primary w-100"> {{isUserLoggedIn ? 'Logout' :
                  'Login/Signup'}}</button></li>
              <li class="options" *ngIf="isUserLoggedIn"><a class="dropdown-item"
                  [routerLink]="'/account/profilePage'">My Profile</a></li>
              <li class="options" *ngIf="isUserLoggedIn"><a class="dropdown-item" [routerLink]="'/account/booking'">My
                  Finance & Bookings</a></li>
              <li class="options" *ngIf="isUserLoggedIn"><a class="dropdown-item" [routerLink]="'/account/testDrive'">My
                  Test Drive</a></li>
              <li class="options" *ngIf="isUserLoggedIn"><a class="dropdown-item" [routerLink]="'/account/wishList'">My
                  Wish List</a></li>
              <li class="options" *ngIf="isUserLoggedIn"><a class="dropdown-item" [routerLink]="'/account/kyc'">My
                  Kyc</a></li>
            </ul>
          </div>

          <div class="menu p-2 d-lg-none">
          </div>


          <div class="tata-logo p-2">
            <span>
              <a href="https://www.tata.com/" target="_blank" rel="noopener noreferrer">
                <!-- <img [src]="environment1 + 'images/new-images/tatalogo.svg'" alt="tatalogo" loading="lazy"> -->
                 <svg width="82" height="18" viewBox="0 0 82 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path fill-rule="evenodd" clip-rule="evenodd"
                    d="M26.016 6.04191C25.6952 5.40635 25.2728 4.79721 24.7472 4.22596C23.5662 2.94165 21.8998 1.87293 19.9278 1.13584C17.9396 0.393038 15.6719 0 13.3674 0C11.0629 0 8.79517 0.393038 6.80797 1.13584C4.83497 1.87302 3.16855 2.94173 1.9875 4.22596C1.4623 4.79712 1.03846 5.40712 0.717773 6.04302C3.28505 5.41751 7.67652 4.59166 11.7541 4.50434C12.1474 4.49583 12.4182 4.62275 12.5965 4.85045C12.8137 5.12772 12.7974 6.11611 12.7921 6.55829L12.6761 17.9874C12.9058 17.9951 13.1365 18 13.3674 18C13.6002 18 13.8322 17.9962 14.0619 17.9885L13.946 6.55821C13.94 6.11611 13.9231 5.12763 14.1411 4.85036C14.3198 4.62275 14.5897 4.49583 14.9829 4.50426C19.0588 4.59089 23.4492 5.41692 26.016 6.04191Z"
                    fill="white" />
                  <path fill-rule="evenodd" clip-rule="evenodd"
                    d="M26.5681 7.52809C22.8107 6.67225 20.3014 6.51398 17.8255 6.37555C15.6674 6.25468 15.6392 7.03113 15.8546 8.51494C15.8687 8.60549 15.8861 8.71964 15.9066 8.8498C16.6305 13.1696 17.532 16.8871 17.6869 17.518C22.9482 16.3063 26.7426 12.9467 26.7426 9.00015C26.7426 8.50319 26.683 8.01082 26.5681 7.52809Z"
                    fill="white" />
                  <path fill-rule="evenodd" clip-rule="evenodd"
                    d="M10.8905 8.51494C11.1062 7.03121 11.0786 6.25468 8.92066 6.37555C6.44394 6.51397 3.93407 6.67216 0.175182 7.5286C0.0603666 8.01133 0 8.5031 0 9.00006C0 10.7058 0.688722 12.3563 1.99193 13.7744C3.17297 15.0587 4.8394 16.1274 6.81239 16.865C7.52648 17.1314 8.28005 17.3497 9.05628 17.5243C9.20195 16.9332 10.1241 13.1385 10.8559 8.74136C10.8694 8.65711 10.8819 8.57934 10.8905 8.51494Z"
                    fill="white" />
                  <path d="M29.7568 2.56348H42.0937V6.34594H38.5545V15.4364H33.4138V6.34594H29.7568V2.56348Z"
                    fill="white" />
                  <path
                    d="M48.3419 7.76465L45.7445 15.4364H40.8076L45.6495 2.56348H51.0111L55.9696 15.4364H50.9721L48.3419 7.76465Z"
                    fill="white" />
                  <path d="M54.791 2.56348H67.1274V6.34594H63.5893V15.4364H58.4488V6.34594H54.791V2.56348Z"
                    fill="white" />
                  <path
                    d="M73.377 7.76465L70.7786 15.4364H65.8418L70.6853 2.56348H76.0452L81.0021 15.4364H76.0064L73.377 7.76465Z"
                    fill="white" />
                </svg>
              </a>
            </span>
          </div>
        </div>
      </div>

    </div>
  </nav>
  <nav class="navbar navbar-dark bg-black-30 navbar-expand-lg p-0 d-lg-block d-none second-menu-border-top">

    <div class="container">
      <div class="row" style="display: contents;">
        <div class="col-9 col-sm-9 col-md-9 col-lg-9 col-xl-9">
          <nav class="navbar">
            <ul class="navbar-nav mb-lg-0 fw-bold">
              <li class="nav-item me-4">
                <a class="nav-link p-0 cursor" data-toggle="tooltip" data-placement="top"
                   (click)="goToadvancesearch()">
                  Smart Search
                </a>
              </li>
              <li class="nav-item me-4">
                <a class="nav-link p-0 cursor" data-toggle="tooltip" data-placement="top"
                  title="Click here to Build your own vehicle" [routerLink]="'/configurator-home'"
                  (click)="callConfigurator();SectionClick('Configurator')">
                  Build your own vehicle
                </a>
              </li>
              <!-- <li class="nav-item me-4">
                <a class="nav-link p-0" href="https://tataok.tatamotors.com/" target="_blank" rel="noopener noreferrer"
                  (click)="SectionClick('Exchange')">
                  Exchange
                </a>
              </li> -->
              <!-- <li class="nav-item me-4">
                <a class="nav-link p-0" [routerLink]="'/compare'" (click)="SectionClick('Compare')">
                  Compare
                </a>
              </li> -->


             <li class="nav-item  me-4  dropdown has-megamenu">
                <a class="nav-link dropdown-toggle cursor pt-0" data-bs-toggle="dropdown" data-bs-auto-close="true" (click)="getBrandCategory(CategoryList[0])"
                aria-expanded="false" >
                Explore Our Brands
              </a>
              <div class="dropdown-menu megamenu brand" style="min-height: 200px;" role="menu" aria-labelledby="navbarDropdown">
                <div class="container">
                  <div class="d-flex align-items-start">
                    <div class="nav flex-column nav-pills mega-vertical-tab ankor" id="v-pills-tab" role="tablist"
                      aria-orientation="vertical">
                      <ul *ngFor="let item of CategoryList;let i =index" class="categories">
                        <li ><a
                             class="megatab active cursor v-pills" id="t21-tab" (click)="gotoCategory(item)" (mouseenter)="Clickcat(item)"
                            data-bs-toggle="pill" data-bs-target="#t21" role="tab" aria-controls="#t21"
                            aria-selected="true" [ngClass]="{'active': selectedCategory === item, 'selected': selectedCategory === item}" >{{item}}       <img alt="caret-right-black"
                            [ngClass]="{'active': selectedCategory === item, 'selected': selectedCategory === item}"
                              [src]='environment1 + "assets/images/caret-right-black.svg"' loading="lazy" />
                            </a></li>
                      </ul>
                    </div>
                    <div class="tab-content mega-vertical-content " id="v-pills-tabContent">
                      <div class="tab-pane fade show active" id="t21" role="tabpanel" aria-labelledby="t21-tab">
                        <div class="container-fluid data-pills">
                          <div class="row g-3 row-cols-4 text-center">
                            <div class="col" *ngFor="let item of CategoryData">
                              <a  class="menu-option" (click)="gotobrand(item.title)" >
                                <div class="brand-menu-img">
                                  <img alt=" {{item.title}}" [src]="item.path" class="img-fluid" loading="lazy" />
                                </div>
                                <div class="menu-title">
                                  {{item.title}}
                                </div>
                              </a>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

              </div>
              </li>
              <li class="nav-item  me-2" *ngIf="isTataEaseAvl">
                <a class="nav-link p-0" href="https://fleetverse.tatamotors.com/keyaccounts/">
                  Key Account Portal
                </a>
              </li>
              <li class="nav-item  me-2" >
                <a class="nav-link p-0" [routerLink]="'/buy-used-vehicles'" >
                  Buy Used Vehicles
                </a>
              </li>
              <li class="nav-item me-2">
                <a
                  class="nav-link p-0"
                  [routerLink]="'/offers'"
                  (click)="SectionClick('Offers')"
                >
                  Finance & Offers
                </a>
              </li>
              <li class="nav-item  me-4">
                <a class="nav-link p-0" [routerLink]="'/help'" (click)="SectionClick('Help')">
                  Help
                </a>
                </li>
            </ul>
          </nav>
        </div>
        <!-- <div class="dealeername col-4 col-sm-4 col-md-4 col-lg-4 col-xl-4"
        *ngIf="dealerName">
          Dealer Name: {{dealerName}}
        </div> -->
        <div style="display: contents;">
          <ul class="navbar-nav mb-lg-0 fw-bold">
          <li class="nav-item  me-2">
            <a class="nav-link p-0 mt-2" >
              Follow Us
            </a>
          </li>
          <li class="nav-item  me-2"><a href="https://m.facebook.com/profile.php?id=61563287553151" target="_blank" rel="noopener noreferrer">
            <img alt="facebook" [src]="environment1+'assets/images/Facebook_icon_2013 2.svg'"  width="100%" height="100%" />
          </a></li>
          <li class="nav-item  me-2">
            <a href="https://www.instagram.com/tatamotorsfleetverse/"  target="_blank" rel="noopener noreferrer">
              <img alt="instagram"  width="100%"[src]="environment1+'assets/images/Instagram_logo_2016 1.svg'"
            height="100%" />
          </a>
        </li>
        <li class="nav-item  me-2">
          <a href="https://www.youtube.com/@TataMotorsFleetVerse" target="_blank" rel="noopener noreferrer">
            <img style="height: 30px;width:30px" alt="youtube" [src]="environment1+'assets/images/youtube-icon.svg'"  width="100%"
          height="100%" />
        </a>
      </li>
        </ul>
        </div>
        <div  *ngIf="dealerName" style="    position: fixed;
        padding: 10px;
        background: #ffffff;
        border-radius: 12px 0 0px 12px;
        margin-top: 90px;
        width: fit-content; color: #2f2f77;right: 0;box-shadow: rgba(149, 157, 165, 0.2) 0px 8px 24px;">
          Dealer Name: {{dealerName}}
        </div>
      </div>
    </div>
  </nav>
</header>
<!--off canvas-->
<!-- mobile view -->
<div class="offcanvas right-offcanvas offcanvas-start" tabindex="-1" id="offcanvasRight"
  aria-labelledby="offcanvasRightLabel">
  <div class="offcanvas-header d-flex align-items-center">
    <span class="me-2" [class.d-none]="selectedMenu?.length == 0">
      <a href="#" class="stepback" (click)="backMenu()"><img class=""
          [src]='environment1 + "assets/images/caret-right-black.svg"' loading="lazy" alt="caret-right-black" /></a>
    </span>
    <h5 class="mb-0">{{selectedMenu[selectedMenuIndex] | titlecase}}</h5>


    <button type="button" id="closeBtnMobile" #closeBtnMobile class="btn-close nav-close text-reset ms-auto"
      data-bs-dismiss="offcanvas" aria-label="Close"></button>
  </div>

  <div class="offcanvas-body d-grid">
    <div class="nav-offcanvas-content">
      <div class="offcanvas-main-nav">
        <ul class="first-nav">
          <li class="item has-sub-menu">
            <a (click)="getTotalMenu('trucks','')">Trucks </a>
            <ul class="second-nav">
              <li class="item has-sub-menu">
                <ng-container *ngFor="let item of menu; let i=index">
              <li class="item has-sub-menu"> <a
                  (click)="onSubMenuClick('trucks',item.name,'html')">{{item.display_name}}
                </a></li>
              <ul class="third-nav">
                <li>
                  <ul>
                    <li *ngFor="let submenu of subMenu">
                      <a data-bs-dismiss="offcanvas" aria-label="Close"
                        (click)="onMenuClick('trucks', submenu.display_ppl)">
                        <span class="img-wrapper">
                          <img [src]="submenu.image" class="img-fluid" loading="lazy">
                        </span>

                        <span class="menu-txt">{{submenu.actual_ppl}}</span>
                      </a>
                    </li>
                  </ul>
                </li>

              </ul>
              </ng-container>
          </li>
        </ul>
        </li>
        <li class="item has-sub-menu">
          <a (click)="getTotalMenu('buses','')">Buses & Vans</a>
          <ul class="second-nav">
            <li class="item has-sub-menu">
              <ng-container *ngFor="let item of menu; let i=index">
            <li class="item has-sub-menu"><a
                (click)="onSubMenuClick('buses',item.name,'html')">{{item.display_name}}</a></li>
            <ul class="third-nav">
              <li>
                <ul>
                  <li *ngFor="let submenu of subMenu">
                    <a data-bs-dismiss="offcanvas" aria-label="Close"
                      (click)="onMenuClick('buses', submenu.display_ppl)">
                      <span class="img-wrapper">
                        <img [src]="submenu.image" class="img-fluid" loading="lazy">
                      </span>

                      <span class="menu-txt">{{submenu.actual_ppl}}</span>
                    </a>
                  </li>
                </ul>
              </li>

            </ul>
            </ng-container>
        </li>
        </ul>
        </li>
        <li class="item has-sub-menu">
          <a (click)="getTotalMenu('SCVPickups','')">SCV & Pickups </a>
          <ul class="second-nav">
            <li class="item has-sub-menu">
              <ng-container *ngFor="let item of menu; let i=index">
            <li class="item has-sub-menu"><a
                (click)="onSubMenuClick('SCVPickups',item.name,'html')">{{item.display_name}}</a></li>
            <ul class="third-nav">
              <li>
                <ul>
                  <li *ngFor="let submenu of subMenu">
                    <a data-bs-dismiss="offcanvas" aria-label="Close"
                      (click)="onMenuClick('SCV Pickups', submenu.display_ppl)">
                      <span class="img-wrapper">
                        <img [src]="submenu.image" class="img-fluid" loading="lazy">
                      </span>

                      <span class="menu-txt">{{submenu.actual_ppl}}</span>
                    </a>
                  </li>
                </ul>
              </li>

            </ul>
            </ng-container>
        </li>
        </ul>
        </li>
        <li class="item has-sub-menu">
          <a (click)="getTotalMenu('Brand','')">Explore Our Brands </a>
          <ul class="second-nav">
            <li class="item has-sub-menu">
              <ng-container  *ngFor="let item of CategoryList;let i =index">
             <li class="item has-sub-menu">
              <a (click)="getBrandCategory(item);onSubMenuClick('Brand',item,'html')">{{item}} </a></li>
              <ul class="third-nav">
                <li>
                  <ul>
                    <li *ngFor="let item of CategoryData">
                      <a data-bs-dismiss="offcanvas" aria-label="Close"
                      (click)="gotobrand(item.title)">
                        <span class="img-wrapper">
                          <img [src]="item.path" class="img-fluid" loading="lazy">
                        </span>

                        <span class="menu-txt">{{item.title}}</span>
                      </a>

                    </li>
                  </ul>
                </li>

              </ul>

            </ng-container>

        </li>
        </ul>
        </li>
        <li class="item has-sub-menu">
          <a (click)="getTotalMenu('Category','')">Explore Our Category </a>
          <ul class="second-nav">
            <li class="item has-sub-menu">
              <ng-container  *ngFor="let item of CategoryList;let i =index">

             <li class="item has-sub-menu">
              <a (click)="gotoCategory(item)" data-bs-dismiss="offcanvas" aria-label="Close">{{item}} </a></li>

            </ng-container>

        </li>
        </ul>
        </li>
        </ul>
      </div>
      <div class="offcanvas-secondary-nav">
        <ul>
          <!-- <li><a data-bs-dismiss="offcanvas" aria-label="Close" [routerLink]="'/genset'" (click)="goTo()">Tata Motors Gensets</a> -->
          <li><a data-bs-dismiss="offcanvas" aria-label="Close" [routerLink]="'/compare'" (click)="goTo()">Compare</a>
          </li>

          <li><a data-bs-dismiss="offcanvas" aria-label="Close" [routerLink]="'/find-dealer'" (click)="goTo()">Dealer
              Outlet Locator</a></li>
          <li><a data-bs-dismiss="offcanvas" aria-label="Close" [routerLink]="'/configurator-home'"
              (click)="callConfigurator()">Build your own vehicle</a>
          </li>
          <li><a data-bs-dismiss="offcanvas" aria-label="Close"
            (click)="goToadvancesearch()">Smart Search</a>
        </li>
        <li>
          <a
            data-bs-dismiss="offcanvas"
            aria-label="Close"
            [routerLink]="'/buy-used-vehicles'"
            >Buy Used Vehicles</a
          >
        </li>
        <li *ngIf="isTataEaseAvl">
          <a href="https://fleetverse.tatamotors.com/keyaccounts/" data-bs-dismiss="offcanvas" aria-label="Close" >
            Key Account Portal
          </a>
        </li>
        <li class="nav-item me-2">
          <a
            class="nav-link p-0"
            [routerLink]="'/offers'"
            (click)="goTo()"
          >
            Finance & Offers
          </a>
        </li>
        <li><a data-bs-dismiss="offcanvas" aria-label="Close" [routerLink]="'/help'" (click)="goTo()">Help</a></li>
        </ul>
      </div>
    </div>

    <div class="nav-offcanvas-footer align-self-end">
      <div class="t-c">
        <ul>
          <li><a data-bs-dismiss="offcanvas" aria-label="Close" [routerLink]="'/terms-conditions'"
              (click)="goTo()">Terms & Conditions</a></li>
          <li><a data-bs-dismiss="offcanvas" aria-label="Close" [routerLink]="'/privacy-policy'"
              (click)="goTo()">Privacy Policy</a></li>
        </ul>
      </div>
      <div class="social-network">
        <ul>
          <li><a href="https://m.facebook.com/profile.php?id=61563287553151" target="_blank" rel="noopener noreferrer">
            <img alt="facebook" [src]='environment1 + "assets/images/Facebook_icon_2013 2.svg"' width="100%" height="100%" />
          </a></li>
          <li>
            <a href="https://www.instagram.com/tatamotorsfleetverse/" target="_blank" rel="noopener noreferrer">
              <img alt="instagram" [src]='environment1 + "assets/images/Instagram_logo_2016 1.svg"' width="100%"
            height="100%" />
          </a>
        </li>
        <li>
          <a href="https://www.youtube.com/@TataMotorsFleetVerse" target="_blank" rel="noopener noreferrer">
            <img style="height: 30px;width:30px" alt="youtube"[src]='environment1 + "assets/images/youtube-icon.svg"' width="100%"
          height="100%" />
        </a>
      </li>
        </ul>
      </div>


    </div>
  </div>
</div>

<!--end off canvas-->

<SerchDummyComponent id="#adcanceSearch"></SerchDummyComponent>
<app-advance-search-slider></app-advance-search-slider>
